/**
 * 轻量级 i18n 国际化模块 - Mozi
 * 支持中文(zh)和英文(en)，无第三方依赖
 */
import { en } from './locales/en'
import { zh } from './locales/zh'

export type Locale = 'en' | 'zh'
export type TranslationKeys = typeof en

const resources: Record<Locale, TranslationKeys> = { en, zh: zh as unknown as TranslationKeys }
let currentLocale: Locale = 'zh'

export function setLocale(locale: Locale): void {
  if (resources[locale]) currentLocale = locale
}

export function getLocale(): Locale { return currentLocale }

export function t(key: string): string {
  const keys = key.split('.')
  let result: any = resources[currentLocale]
  for (const k of keys) {
    if (result == null) return key
    result = result[k]
  }
  return typeof result === 'string' ? result : key
}

export function getSupportedLocales(): { code: Locale; label: string }[] {
  return [
    { code: 'en', label: 'English' },
    { code: 'zh', label: '简体中文' },
  ]
}

export function detectAndSetLocale(): Locale {
  if (typeof navigator !== 'undefined') {
    const lang = navigator.language || 'en'
    if (lang.startsWith('zh')) { setLocale('zh'); return 'zh' }
  }
  if (typeof process !== 'undefined' && process.env) {
    const lang = process.env.LANG || process.env.LANGUAGE || process.env.LC_ALL || ''
    if (lang.startsWith('zh')) { setLocale('zh'); return 'zh' }
  }
  setLocale('en')
  return 'en'
}

export { en, zh }
